<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="mt-4 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">环境数量</th>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900">有效天数</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">创建时间</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">开始时间</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">结束时间</th>
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">操作</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in tableData" :key="item.id">
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{item.Value}}个</td>
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">{{item.TimeDay}}天</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.AddTime}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.StartTime}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.EndTime}}</td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="view(item)" title="关联订单详情" v-if="item.OrderNo.length">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z" />
                      </svg>
                    </a>
                    <!-- <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="deleteItem(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                      </svg>
                    </a> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Pagination :size="query.PageSize" :page="query.PageIndex" :total="total" @change="changePage" />
    <Alert :visible.sync="alertShow" ref="alert" />
    <Notify ref="notify" />
    <Modal :visible.sync="detailDialog" title="关联订单详情" :ActionBtnShow="false" width="max-w-3xl">
      <div class="space-y-6 sm:space-y-0 my-4 mx-2 px-4 py-0" v-if="Object.keys(detail)">
        <div>
          <h2 class="text-base font-extrabold text-gray-900 mt-6">{{detail.GoodsTitle}}</h2>
        </div>
        <div class="mt-4 block">
          <div class="relative block box-border text-sm">
            <div class="text-gray-900 my-2"><span class="text-gray-500">订单号：</span>{{detail.OrderNo}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">商品数量：</span>{{detail.BuyValue}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">订单金额：</span>{{detail.RealAmount}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">创建时间：</span>{{detail.AddTime}}</div>
            <div class="text-gray-900 my-2" v-if="detail.IsInvoice"><span class="text-gray-500">发票抬头：</span>{{detail.InvoiceTitle}}</div>
            <div class="text-gray-900 my-2" v-if="detail.IsInvoice"><span class="text-gray-500">统一社会信用代码：</span>{{detail.InvoiceCode}}</div>
            <div class="text-gray-900 my-2" v-if="detail.IsInvoice"><span class="text-gray-500">电 子 邮 箱：</span>{{detail.InvoiceEmail}}</div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">支付方式：</span>
              <span v-if="detail.PaymentType === 0">限免</span>
              <span v-else-if="detail.PaymentType === 1">支付宝</span>
              <span v-else-if="detail.PaymentType === 2">微信</span>
              <span v-else-if="detail.PaymentType === 3">积分</span>
            </div>
            <div class="text-gray-900 my-2"><span class="text-gray-500">支付状态：</span>
              <span v-if="detail.PaymentStatus === 1" class="text-green-600">已支付</span>
              <span v-else-if="detail.PaymentStatus === 0" class="text-[#f00]">待支付</span>
              <span class="text-red" v-else>--</span>
              <!-- <span class="text-indigo-600 underline cursor-pointer" @click="goPay(detail)" v-if="detail.PaymentStatus === 0">继续支付</span> -->
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Pagination from '../components/Pagination.vue'
import Alert from '../components/Alert.vue'
import Notify from '../components/Notification.vue'
import { pageFbList as pageList, remove, repay, queryOrder } from '../api/FBOrder.js'
import { getCurrentUser } from '../api/App'
import { debounce } from 'lodash'
import Modal from '../components/Modal.vue'
export default {
  name: 'CommentList',
  components: { Alert, Notify, Pagination, Modal },
  data () {
    return {
      alertShow: false,
      modalShow: false,
      detailDialog: false,
      query: {
        PageIndex: 1,
        PageSize: 10,
        PaymentStatus: -1,
        sort: '-Id'
      },
      detail: {},
      tableData: [],
      total: 0,
      addDialog: false,
      addForm: { Count: 1, UserId: 0, CodeType: 0, ValidityPeriodDay: 0 },
      user: null
    }
  },
  mounted () {
    this.getList()
    this.getUser()
  },
  methods: {
    openBlankUrl (url) {
      var a = document.createElement('a')
      a.style.display = 'none'
      a.setAttribute('target', '_blank')
      a.href = url
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    goPay (row) {
      repay({ orderKey: row.Key, payType: row.PaymentType }).then(res => {
        if (row.PaymentType == 1) {
          this.openBlankUrl(res.data.data.Url, '_blank')
          return
        }
        if (row.PaymentType == 2) {
          this.openBlankUrl(`/wechatpay.html?key=${res.data.data.Key}&data=${res.data.data.Url}`, '_blank')
          return
        }
      }).catch(err => { console.log(err) })
    },
    getUser () {
      getCurrentUser().then(res => {
        this.user = res.data.data
      }).catch(err => { console.log(err) })
    },
    batchAdd () {
      this.addForm = { Count: 1, UserId: this.user.id, CodeType: 0, ValidityPeriodDay: 0 }
      this.addDialog = true
    },
    view (detail) {
      queryOrder(detail.OrderNo).then(res => {
        this.detail = res.data.data
        this.detailDialog = true
      }).catch((err) => {
        console.log(err)
      }).finally(() => {})
    },
    changePage (page) {
      this.query.PageIndex = page
    },
    deleteItem (item) {
      this.alertShow = true
      new Promise((resolve, reject) => {
        const instance = this.$refs.alert
        instance.confirm = () => {
          this.alertShow = false
          resolve()
        }
        instance.cancel = () => {
          this.alertShow = false
          reject()
        }
      }).then(() => {
        remove(item.Key).then(() => {
          this.notifyShow({ title: '删除成功' })
          this.getList()
        })
      }).catch(() => { console.log('cancel') })
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    getList () {
      this.loading = true
      pageList(this.queryString).then(res => {
        const data = res.data.data
        if (!data.list) data.list = []
        this.tableData = data.list
        this.query.PageIndex = data.page ? data.page : 1
        this.total = data.total ? data.total : 0
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  },
  computed: {
    queryString: function () {
      return Object.keys(this.query).filter(key => this.query[key] !== '')
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.query[key]))
        .join('&')
    }
  }
}
</script>
